import * as React from "react";
import { Draggable } from "react-beautiful-dnd";
import { WebPortalClient, Phase, StudyPhase } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { SessionItems } from "./SessionItems";
import { ActiveItem, ScheduleVisit } from "./VisitSchedule";
import { GetReferenceOrStudyPhases } from "./VisitConfiguration";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";

export interface VisitGroupProps {
    visit: ScheduleVisit;
    index: number;
    setActive: (item: ActiveItem) => void;
    addSession: () => void;
    isSessionDropDisabled: boolean;
    phases: StudyPhase[];
}

export const VisitGroup = ({
    visit,
    index,
    setActive,
    addSession,
    isSessionDropDisabled,
    phases
}: VisitGroupProps) => {
    const grid = 8;
    const getItemStyle = (isDragging, draggableStyle) => {
        return {
            // some basic styles to make the items look a bit nicer
            userSelect: "none",
            padding: grid * 2,
            margin: `0 0 ${grid}px 0`,
            textAlign: "left",
            background: isDragging ? "lightgreen" : "#fff",
            ...draggableStyle
        };
    };

    return (
        <Draggable key={visit.id} draggableId={visit.id} index={index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                >
                    <div {...provided.dragHandleProps} onClick={e => e.stopPropagation()}>
                        <div className="row">
                            <h3 className={`col-md-11 ${visit.disabled ? "text-danger" : "text-primary"}`}>
                                <FontAwesomeIcon icon={faGripVertical} />&nbsp;
                                <span data-automationid={visit.label}>{visit.label}</span>{" "}
                                <small>
                                    {phases.length > 0 && phases.find(p => p.id === visit.phase).name}
                                </small>
                            </h3>
                            <div className="col-md-1">
                                <button
                                    data-automationid={`VisitGroup-${visit.label}`}
                                    className="btn btn-primary btn-outline"
                                    onClick={() => setActive({ id: visit.id, type: "Visit", visitId: visit.id })}
                                >
                                    Edit
                                </button>
                            </div>
                        </div>
                    </div>

                    <SessionItems
                        visitNum={index}
                        visit={visit}
                        dropDisabled={isSessionDropDisabled}
                        setActive={id => setActive({ id: id, type: "Session", visitId: visit.id })}
                    />
                    <button
                        className="btn btn-primary"
                        data-automationid="VisitScheduleAddSessionButton"
                        onClick={e => {
                            e.stopPropagation();
                            addSession();
                        }}
                    >
                        Add Session
                    </button>
                </div>
            )}
        </Draggable>
    );
};
